import {Link} from "react-router-dom";
import {urlService} from "../../../../routing/urlsService";
import KeyValueContainer from "../../../../shared/KeyValueContainer";

import React, {useContext, useEffect, useState} from "react";
import {ITagMetrics, IPartner} from "@leap4/entities-discrepancy-common";
import {UserViewsContext} from "../../../../../contexts/userViewsContext";
import {extractOverviewMetrics, getMetricChangePercent} from "../../../common/OverviewGeneralInfo/OverviewHelpers";
import {SingleMetricForCard} from "../../../common/OverviewGeneralInfo/SingleMetric";
import {metricEnumKeyMap} from "../../../../../utils/enums";
import {Card, Grid, Mui} from "@leap4/frontend";

export interface IPartnerCardProps {
    partner: IPartner
    totals: ITagMetrics,
    compareData: ITagMetrics
}

export const PartnerCard = ({partner, totals, compareData}: IPartnerCardProps): JSX.Element => {
    const {userViews} = useContext(UserViewsContext)
    const [initialAllMetrics, setAllMetrics] = useState(extractOverviewMetrics(totals))
    const [selectedDatesMetrics, setSelectedMetrics] = useState(extractOverviewMetrics(totals))
    const [compareDataMetrics, setCompareDataMetrics] = useState(extractOverviewMetrics(compareData))
    useEffect(() => {
        const {cardViews} = userViews.activePreset
        const newSelectedMetrics = {}
        cardViews.forEach(view => {
            newSelectedMetrics[view] = initialAllMetrics[view]
        })
        setSelectedMetrics(newSelectedMetrics as any)
        setCompareDataMetrics(extractOverviewMetrics(compareData))
    }, [userViews, compareData])
    return <Card
        sx={{
            width: {
                lg: 500,
                xs: 350
            },
            margin: '10px auto', boxShadow: 'none', borderRadius: '16px'
        }}
        header={{
            title: partner?.name.toUpperCase(),
        }
        }
        actionsArea={{
            children:
                <Link
                    to={urlService.partnerOverview(partner?._id.toString(), true)}
                >
                    <Grid
                        alignContent="space-between" alignItems="center" container>

                        <Grid item xs={12}>

                            <h2 style={{fontStyle: "oblique", marginTop: 0, marginBottom: "12px", textAlign: "center"}}>TOTALS</h2>
                            {Object.keys(selectedDatesMetrics).map(key =>
                            {
                                let compareVal
                                if(!compareDataMetrics) compareVal = null
                                else compareVal = compareDataMetrics[key]
                             return(
                                <KeyValueContainer
                                    key={key}
                                    title={metricEnumKeyMap[key].label.toUpperCase()}
                                    value={
                                        <SingleMetricForCard
                                        metricValue={selectedDatesMetrics[key] as number} metricEnum={metricEnumKeyMap[key].label}
                                        metricChange={getMetricChangePercent(selectedDatesMetrics[key], compareVal)}
                                        />
                                    }
                                />
                             )
                            }
                            )
                            }
                        </Grid>
                    </Grid>
                </Link>
        }
        }
    />
}